import { useTenantCurrent } from '../lib/hooks';
import { Icon } from './ui';

export function HelpSupportButton() {
  const { data: tenant } = useTenantCurrent();
  const supportEmail = tenant?.branding?.supportEmail || 'smcteam@shaemarcus.com';

  return (
    <a className="help-pill" href={`mailto:${supportEmail}`}>
      <span className="help-pill-icon" aria-hidden="true">
        <Icon.Help size={15} />
      </span>
      <span className="help-pill-copy">
        <strong>Questions? We can help</strong>
        <span>{supportEmail}</span>
      </span>
    </a>
  );
}
